import React from 'react';
import styled from 'styled-components';
import { cssColorValue, Image, semanticColors } from '@spotify-internal/encore-web';

const RoundedImage = styled(Image)`
  background-color: ${cssColorValue(semanticColors.backgroundHighlight)};
  border-radius: 50%;
  object-fit: cover;
`;

interface UserProfileImageProps {
  src: string;
  width: number;
  height: number;
  alt: string;
}

const UserProfileImage = ({ src, width, height, alt }: UserProfileImageProps) => {
  return <RoundedImage src={src} width={width} height={height} alt={alt} role="img" data-testid="user-profile-image" />;
};

export default UserProfileImage;
